import { RouteProps } from '../../routes/AppRouter'
import { ClinicsTable } from '../../features/clients'
import { Title } from '../../components/common/Title'

export const Table = (props: RouteProps) => {
  return (
    <>
      <Title color={"black"} title={props.title || ''} />
      <ClinicsTable  />
    </>
  )
}
